module.exports = __webpack_public_path__ + "img/sw-ps-xs.40cf57e4.webp";